import { CSSProperties } from 'react';
import '../assets/Sparkles.css';
import { useEffect } from 'react';

interface SparklesProps
{
    count?: number;
    maxSize?: number;
}
export default function Sparkles(props: SparklesProps) 
{
    const count = props.count || 20;
    const maxSize = props.maxSize || 4;

    useEffect(() => {
        function setViewPortVars()
        {
            document.body.style.setProperty('--windowWidth', `${window.innerWidth}`);
            document.body.style.setProperty('--windowHeight', `${window.innerHeight}`);
        }
        window.addEventListener('resize', setViewPortVars);
        setViewPortVars();

        return () => {
            window.removeEventListener('resize', setViewPortVars);
        }
    }, [])
    
    return (
        <div className="sparkles-container">
            {Array.from({length: count}).map((_, i) => {
                const size = 1 + Math.ceil( Math.random() * maxSize);
                const height = size;
                const width = size;
                const left = (Math.random() + 0.1) * 80;
                const top = (Math.random() + 0.1) * 80;
                const duration = 2 + Math.random() * 20;
                const delay = Math.random() * 2;
                const distX = (Math.random()-0.5) *( window.innerWidth / 5 );
                const distY = (Math.random()-0.5) *( window.innerHeight / 5 );
                return(

                <div className="sparkle" key={i} style={{
                    width: `${width}px`,
                    height: `${height}px`,
                    left: `${left}%`,
                    top: `${top}%`,
                    animationDelay: `${delay}s`,
                    animationDuration: `${duration}s`,
                    animationTimingFunction: 'ease-in-out',
                    animationIterationCount: 'infinite',
                    ['--dist-x' as keyof CSSProperties]: `${distX}px`,
                    ['--dist-y' as keyof CSSProperties]: `${distY}px`,
                    ['--xInitial' as keyof CSSProperties]: `${left / 100 *  window.innerWidth}`,
                    ['--yInitial' as keyof CSSProperties]: `${top / 100 * window.innerHeight}`,
                    ['--distXnumber' as keyof CSSProperties]: `${(distX)}`,
                    ['--distYnumber' as keyof CSSProperties]: `${(distY)}`,
                }}>
                </div>
            )})}
        </div>
    )
}
